import { render, staticRenderFns } from "./LiveExpired.vue?vue&type=template&id=b753b5f6&scoped=true&"
import script from "./LiveExpired.vue?vue&type=script&lang=js&"
export * from "./LiveExpired.vue?vue&type=script&lang=js&"
import style0 from "./LiveExpired.vue?vue&type=style&index=0&id=b753b5f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b753b5f6",
  null
  
)

export default component.exports